var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "uploaded-file-list mx-3",
      attrs: { "data-cy": "file-records" },
    },
    [
      _vm.hasError
        ? _c(
            "div",
            { staticClass: "alert alert-danger", attrs: { role: "alert" } },
            [
              _c("p", [
                _vm._v(
                  "Ein Fehler ist aufgetreten, bitte versuche es später noch einmal."
                ),
              ]),
            ]
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "ul",
        { staticClass: "list-unstyled" },
        _vm._l(_vm.files, function (file, index) {
          return _c(
            "li",
            {
              key: `attachment-${index}`,
              staticClass:
                "d-flex justify-content-between align-items-center mb-3",
            },
            [
              _c("div", { staticClass: "attachment-metadata pl-3" }, [
                _c("i", { staticClass: "far fa-file" }),
                _vm._v(" "),
                _c("span", [
                  file.fileType
                    ? _c("b", [_vm._v(_vm._s(file.fileType) + ":")])
                    : _vm._e(),
                  _vm._v(" " + _vm._s(file.metadata.filename) + " "),
                  file.status
                    ? _c("span", { staticClass: "badge badge-info pl-3" }, [
                        _vm._v(" " + _vm._s(file.status)),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("br"),
                  _vm._v(" "),
                  file.comment
                    ? _c("span", { staticClass: "pl-3" }, [
                        _c("b", [_vm._v("Bemerkung:")]),
                        _vm._v(" " + _vm._s(file.comment)),
                      ])
                    : _vm._e(),
                ]),
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "attachment-actions d-flex" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "btn btn-outline-secondary mr-2",
                      attrs: {
                        href: `/api/v1/my-scholarship/process/${file.processId}/attachment/${file.id}`,
                        target: "_blank",
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Datei anzeigen\n                "
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "confirmation-button",
                    {
                      staticClass: "mr-2",
                      attrs: {
                        "button-icon": "Trash",
                        "button-variant": "outline-danger",
                        "button-size": "",
                        title: "Datei wirklich löschen?",
                        description: "Soll die Datei wirklich gelöscht werden?",
                        variant: "danger",
                        "confirm-button-variant": "danger",
                        "confirm-button-title": "Datei löschen",
                      },
                      on: {
                        confirm: function ($event) {
                          return _vm.removeFile(file.processId, file.id)
                        },
                      },
                    },
                    [
                      _vm._v(
                        "\n                    Datei löschen\n                "
                      ),
                    ]
                  ),
                ],
                1
              ),
            ]
          )
        }),
        0
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }